import type { HttpClient } from '../http';
import { unwrap, type ApiEnvelope } from '../envelope';
import type { ClientView, MyCoach } from '../types/domain';

export function clientViewEndpoints(http: HttpClient) {
  return {
    get: () => http.get<ApiEnvelope<ClientView>>('/v1/me/client-view').then(unwrap),
    coaches: () => http.get<ApiEnvelope<MyCoach[]>>('/v1/me/coaches').then(unwrap),
  };
}
export type ClientViewEndpoints = ReturnType<typeof clientViewEndpoints>;
